import { getDefaultState } from '@/store/Libraries/state';
export const mutations = {
  setLibrariesList(state, payload) {
    state.librariesList = payload;
  },
  setIsFetchingLibraries(state, payload) {
    state.isFetchingLibraries = payload;
  },
  setSortingMode(state, payload) {
    state.sortingMode = payload;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};
